import React, { useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import useInactivityHandler from "../utils/InactivityHandler";
import { FaCheckCircle, FaRobot, FaExternalLinkAlt } from "react-icons/fa";

const Premium = () => {
  const { fullname } = useAuth();

  useInactivityHandler();

  useEffect(() => {
    const disableRightClick = (e) => e.preventDefault();
    document.addEventListener("contextmenu", disableRightClick);

    return () => {
      document.removeEventListener("contextmenu", disableRightClick);
    };
  }, []);

  return (
    <div className="flex min-h-screen bg-gradient-to-br from-teal-50 via-gray-50 to-blue-50">
      <div className="flex-grow flex items-center justify-center p-6">
        <div className="p-10 bg-white rounded-2xl shadow-2xl max-w-lg w-full border border-gray-100">
          {/* Success Icon */}
          <div className="flex justify-center mb-6">
            <div className="relative">
              <div className="absolute inset-0 bg-teal-200 rounded-full blur-xl opacity-60 animate-pulse"></div>
              <FaCheckCircle className="relative text-teal-600 text-6xl" />
            </div>
          </div>

          {/* Welcome Message */}
          <h1 className="text-2xl sm:text-3xl font-bold mb-2 text-center text-gray-800">
            Hey, {fullname}!
          </h1>

          {/* Access Granted Badge */}
          <div className="inline-block px-6 py-2 bg-gradient-to-r from-teal-500 to-teal-600 rounded-full mb-6 mx-auto w-full text-center">
            <h2 className="text-xl font-bold text-white flex items-center justify-center gap-2">
              <FaRobot className="text-2xl" />
              AI Access Granted
            </h2>
          </div>

          {/* Description */}
          <p className="text-gray-600 mb-8 text-center text-lg">
            Your premium AI trading assistant is ready to help you maximize your trading potential.
          </p>

          {/* CTA Button */}
          <a
            href="https://ai.money8gg.com"
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full py-4 px-6 bg-gradient-to-r from-teal-600 to-teal-700 text-white rounded-xl font-semibold text-lg shadow-lg hover:shadow-xl hover:from-teal-700 hover:to-teal-800 transition-all duration-300 transform hover:scale-105 mb-4"
          >
            <span className="flex items-center justify-center gap-2">
              Launch AI Assistant
              <FaExternalLinkAlt className="text-sm" />
            </span>
          </a>

          {/* Alternative Access Info */}
          <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
            <p className="text-sm text-gray-600 text-center">
              Or visit directly:{" "}
              <span className="font-mono font-semibold text-teal-700">
                ai.money8gg.com
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Premium;
